<div class="empty-and-loading-state flex flex--column flex--center ms-large">
  <fcom-icon class="icon-xxlarge" [name]="SvgLibraryIcon.FLIGHTS_UNAVAILABLE"></fcom-icon>
  <h2 class="font-heading-3 ms-xxsmall-b ms-medium-t">
    {{ 'flightFilters.noFilterResults.title' | finLocalization }}
  </h2>
  <p class="ms-medium-b">{{ 'flightFilters.noFilterResults.subtitle' | finLocalization }}</p>
  <fcom-button [text]="'flightFilters.clearAll' | finLocalization" (clickBtn)="clearAllFilters.emit()" />
</div>
